import styled from 'styled-components';
import { squareBulletPoints } from '../styled/lists';

export const Italic = styled.span`
  font-style: italic;
`;

export const DividerWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.small};
`;

export const HorizontalRule = styled.div`
  border-bottom: 8px solid ${({ theme }) => theme.palette.lightBackground};
  color: ${({ theme }) => theme.palette.border};
`;

export const Summary = styled.p`
  margin: ${({ theme }) => theme.spacing.small} 0
    ${({ theme }) => theme.spacing.tiny} 0;
`;

export const Section = styled.span`
  display: inline-block;
  font-size: ${({ theme }) => theme.fontsize.standard};
  color: ${({ theme }) => theme.palette.standardText};
  background: ${({ theme }) => theme.palette.lightBackground};
  margin-top: ${({ theme }) => theme.spacing.small};
  padding: 2px 4px;
`;

export const FilterSubheading = styled.legend`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const ResultsList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: ${({ theme }) => theme.spacing.xlarge};
  border-bottom: 1px solid ${({ theme }) => theme.palette.border};
`;

export const ResultItemWrapper = styled.li`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  border-top: 1px solid ${({ theme }) => theme.palette.border};
`;

export const BestBetWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.lightBackground};
  padding: 1.5em;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  h3 {
    margin-top: 0;
  }
`;

export const SuggestionsListWrapper = styled.ul`
  ${squareBulletPoints}
`;

export const Label = styled.h3`
  font-size: ${({ theme }) => theme.fontsize.h4};
  margin-bottom: ${({ theme }) => theme.spacing.small};
  margin-top: ${({ theme }) => theme.spacing.small};
`;

export const LegalRedirectWrapper = styled.div`
  p,
  a {
    font-size: ${({ theme }) => theme.fontsize.h4};
  }
`;

export const TipsList = styled.ul`
  ${squareBulletPoints}
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
